"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function withStatusHandling(statusHandlerDescription) {
  return {
    statusHandler: function statusHandler(dispatch, response, state) {
      return statusHandlerDescription[response.status] ? statusHandlerDescription[response.status](dispatch, response, state) : function () {
        return true;
      };
    }
  };
}

var _default = withStatusHandling;
exports["default"] = _default;